import { api } from "@api/api";
import { appendFormData } from "@core/utils/appendFormData";
import { Book } from "@modules/books/types";
import { BookFormValues } from "@modules/books/validations";

export async function editBookService(
  id: string,
  data: Partial<BookFormValues>
): Promise<Book> {
  if (typeof data.cover === "string") {
    delete data.cover;
  }
  if (typeof data.file === "string") {
    delete data.file;
  }

  const formatedData = appendFormData(data);
  const headers: any =
    formatedData instanceof FormData
      ? { "Content-Type": "multipart/form-data" }
      : { "Content-Type": "application/json" };

  const { data: book } = await api.patch(`v1/book_admin/${id}/`, formatedData, {
    headers,
  });

  return book;
}
